const ADDRESS_TYPE = {
  ALL: 'All',
  BILLING: 'Billing',
  CUSTOMER: 'Customer',
  COMPANY: 'Company',
};

export default ADDRESS_TYPE;
